import styles from './NaviTable.module.scss';
import { INaviTable, NaviTableVariants, PaginationOptions } from './interfaces';
import useNaviTable from './hooks/useNaviTable';
import { INaviTableContextValue, NaviTableProvider } from './context/NaviTableContext';
import NaviTableHeader from './components/NaviTableHeader/NaviTableHeader';
import NaviTableBody from './components/NaviTableBody/NaviTableBody';
import NaviTablePagination from './components/NaviTablePagination/NaviTablePagination';
import { RowData } from '@tanstack/react-table';
import cx from 'classnames';
import TableLoader from '../TableLoader/TableLoader';

const NaviTable = <TData extends RowData>(props: INaviTable<TData>) => {
  const {
    variant = NaviTableVariants.DEFAULT,
    tableClasses,
    tableContainerClasses,
    data,
    loading,
    paginationType = PaginationOptions.SERVER_SIDE,
    sizeColumnsToFit = true,
    totalElements,
    emptyDataComponent,
    showPaginationComponent = true
  } = props;
  const naviTableDetails = useNaviTable<TData>(props);
  const { tableRef, table, handleScroll } = naviTableDetails;

  const showPagination =
    showPaginationComponent && paginationType && totalElements && !loading && data.length > 0;

  return (
    <NaviTableProvider value={{ ...props, ...naviTableDetails } as INaviTableContextValue<unknown>}>
      <div className={cx('relative w-full h-full flex flex-col', tableContainerClasses)}>
        <NaviTableHeader />
        <div
          className={cx(
            'flex-1',
            styles.tableContainer,
            {
              [styles.tableVariantDefault]: variant === NaviTableVariants.DEFAULT,
              [styles.tableWithPagination]: showPagination
            },
            tableClasses
          )}
          onScroll={handleScroll}
        >
          <div
            className={styles.table}
            style={{
              width: sizeColumnsToFit ? '100%' : table.getTotalSize()
            }}
            ref={tableRef}
          >
            <NaviTableBody />
          </div>
        </div>
        {showPagination ? <NaviTablePagination /> : null}
      </div>
    </NaviTableProvider>
  );
};

export default NaviTable;
